import config from 'config';
import { calculatePercentage } from 'src/helpers/math';
import { get } from './common';

export interface AlternativeProjectResource {
  targetCurrency: Currency;
  amountRaised: number;
  progress: number;
  pitch: string;
  owner: string;
  numberOfSupporters: number;
  projectImage: {
    url: string;
    width?: number;
    height?: number;
    cropArea?: {
      top: number;
      left: number;
      width: number;
      height: number;
    };
  };
  projectId: string;
  projectUrl: string;
  ownerId: string;
}

export default async function getAlternativeProjects(
  projectId: string
): Promise<AlternativeProjectResource[]> {
  const url = `v1/entities/alternativeProjects/${projectId}`;

  const result = await get<any>(url, {
    baseUri: config.DISCOVER_API_URI,
    timingName: 'alternativeProjects',
    autoRefreshAccessToken: false,
  });

  if (!result._embedded || !result._embedded.alternativeproject) {
    return [];
  }

  return result._embedded.alternativeproject.map(mapCardToProject);
}

function mapCardToProject(card: any): AlternativeProjectResource {
  const page: AlternativeProjectResource = {
    targetCurrency: card.TargetCurrency,
    amountRaised: card.AmountRaised,
    progress: calculatePercentage(card.AmountRaised, card.TargetAmount),
    pitch: card.What,
    owner: card.Creator.FirstName,
    numberOfSupporters: card.TotalDonations,
    ownerId: card.Creator.UserGuid,
    projectImage: {
      url: card.PhotoUrl,
    },
    projectId: card.AskId,
    projectUrl: card.Url,
  };

  if (card.PhotoDetails) {
    page.projectImage = {
      ...page.projectImage,
      width: card.PhotoDetails.Width,
      height: card.PhotoDetails.Height,
      cropArea: {
        left: card.PhotoDetails.CropLeft,
        top: card.PhotoDetails.CropTop,
        width: card.PhotoDetails.CropWidth,
        height: card.PhotoDetails.CropHeight,
      },
    };
  }

  return page;
}



// WEBPACK FOOTER //
// ./src/helpers/api/alternativeProjects.ts